import { SectionCard } from '../common/SectionCard';
import TradesTable from './TradesTable';
import EquityCurveChart from '../performance/EquityCurveChart';
import DrawdownChart from '../performance/DrawdownChart';
import MonthlyReturnsChart from '../performance/MonthlyReturnsChart';
import type { BacktestResult } from '../../services/backtestApi';
import '../performance/PerformanceLayout.css';

interface BacktestResultPanelProps {
  result: BacktestResult;
  interpretation: string | null;
}

export default function BacktestResultPanel({
  result,
  interpretation,
}: BacktestResultPanelProps) {
  return (
    <SectionCard
      title="실행 결과"
      subtitle={`${result.symbol} · ${result.strategy} (${result.start_date} → ${result.end_date})`}
    >
      <div className="backtest-metrics">
        <Metric label="총 수익률" value={`${result.total_return.toFixed(2)}%`} tone={result.total_return >= 0 ? 'positive' : 'negative'} />
        <Metric label="샤프 지수" value={result.sharpe_ratio.toFixed(2)} />
        <Metric label="승률" value={`${result.win_rate.toFixed(2)}%`} />
        <Metric label="최대 낙폭" value={`${result.max_drawdown.toFixed(2)}%`} tone="warning" />
        <Metric label="완료 거래" value={`${result.total_trades}건`} />
      </div>

      {interpretation && <div className="backtest-interpretation">{interpretation}</div>}

      <div className="backtest-chart-grid">
        <EquityCurveChart data={result.equity_curve} />
        <DrawdownChart data={result.drawdown_series} />
        <MonthlyReturnsChart data={result.monthly_returns} />
      </div>

      <TradesTable trades={result.trade_log} />
    </SectionCard>
  );
}

function Metric({ label, value, tone = '' }: { label: string; value: string; tone?: string }) {
  return (
    <div className={`backtest-metric ${tone}`}>
      <p className="backtest-metric-label">{label}</p>
      <strong className="backtest-metric-value">{value}</strong>
    </div>
  );
}
